export default __webpack_public_path__ + "static/media/theirontower.db9e34fe.jpg";